// extracted by mini-css-extract-plugin
module.exports = {"root":"Badge_root__3tR1p","withContent":"Badge_withContent__2O6Ea","content":"Badge_content__3zje8"};